import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { MessageService, ConfirmationService } from 'primeng/api';
import { CasoClinico } from 'src/app/models/caso-clinico.interface';
import { AdministradorService } from 'src/app/services/administrador.service';
import { SEXO } from '../../../../shared/constantes/constants';
import { Catalogo, TipoSexo } from 'src/app/models/catalogos.interface';
import { environment } from 'src/environments/environment';
@Component({
    selector: 'app-supervisor-casoclinico',
    templateUrl: './supervisor-casoclinico.component.html',
    styleUrls: ['./supervisor-casoclinico.component.scss'],
    providers: [MessageService, ConfirmationService]
})
export class SupervisorCasoclinicoComponent {
    readonly urlBase: string = environment.urlbase;
    readonly urlBack: string = environment.urlBack;
    readonly uri: string = environment.directorios.casosclinicos;
    idCasoClinico: string = '0';
    casoClinico!: CasoClinico;
    sexo: TipoSexo[] = SEXO;

    constructor(
        private location: Location,
        private activedRoute: ActivatedRoute,
        private administradorService: AdministradorService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService) {
        this.idCasoClinico = this.activedRoute.snapshot.params['id'];
        this.getCasoClinico(this.idCasoClinico);
    }

    getCasoClinico(id: string): void {

        this.administradorService.getCasoClinico(id).subscribe({
            next: (resp) => {
                this.showSuccess(resp.mensaje);
                this.casoClinico = resp.datos;
                console.log(resp)
            },
            error: (err: HttpErrorResponse) => {
                this.showError(err.error.message);
                console.log(err)
            }
        });

    }
    deleteSelectedDocumentos(id: number): void {
        this.confirmationService.confirm({
            message: 'Estás seguro de quitar el documento?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.administradorService.elimiarDocumento(id)
                    .subscribe({
                        next: (resp) => {
                            this.casoClinico.documentos = resp.datos;
                            this.showSuccess('Documento/Archivo descartado ');
                        },
                        error: (err: HttpErrorResponse) => { this.showError(err.error.message); console.log(err); }
                    })

            }
        });
    }
    exportPDF(): void {
        const url = environment.urlbase + environment.pdfs.expedienteclinico + this.idCasoClinico;
        window.open(url, '_blank');
    }
    getSexo(abr: string): string {
        let vSexo: string = '';
        let itemSexo: TipoSexo | undefined = undefined;
        itemSexo = this.sexo.find((item) => item.abr == abr);
        if (itemSexo) vSexo = itemSexo.descripcion;
        return vSexo;
    }
    getUsoProducto(items: Catalogo[]): string {
        let descripcion: string = '';
        if (items != undefined) if (items.length > 0) descripcion = items[0].descripcion;
        return descripcion;
    }
    showSuccess(mensaje: string): void {
        this.messageService.add({
            severity: 'success',
            summary: 'Éxito',
            detail: mensaje
        });
    }
    showError(mensaje: string): void {
        this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: mensaje
        });
    }
    regresar(): void {
        this.location.back();
    }
}
